export const ROUTING_DELAY = 700;
export const DEVICE_UID = 'device_uid';
export const OWNER_PHONE = 'owner_phone';
export const REDIRECT_TO = 'redirect_to';
